import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Box, Text, Flex, Button } from '@hausgold/designsystem';
import { useContext, useState } from 'react';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import { getNextButtonText } from '../../../services/models/dialog.js';
import ProgressBarCTA from './ProgressBarCTA.js';
import { jsx } from '@emotion/react';
var CustomNavigationButtonsStart = function CustomNavigationButtonsStart() {
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    NavigationButtonsLayoutContainer = _useContext2.components.NavigationButtonsLayoutContainer;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMessage = _useState2[0],
    setShowMessage = _useState2[1];
  return jsx(NavigationButtonsLayoutContainer, {
    flexDirection: "column"
  }, jsx(Box, {
    textAlign: "center",
    visibility: showMessage ? 'block' : 'hidden'
  }, jsx(Text, {
    mb: 0,
    color: "red.400"
  }, "Bitte w\xE4hlen Sie eine Immobilie aus.")), jsx(Box, {
    width: "100%"
  }, jsx(Flex, {
    width: "100%",
    justifyContent: "flex-end",
    mb: 4
  }, jsx(Button, {
    colorScheme: "red",
    className: "next"
    // this is used in order to not have the button stuck in :focus state
    ,

    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    onClick: function onClick() {
      setShowMessage(true);
    }
  }, getNextButtonText(data))), jsx(ProgressBarCTA, null)));
};
export { CustomNavigationButtonsStart as default };